import { Pipe, PipeTransform } from '@angular/core';
import { Role } from '../classes/auth/role.class';
import { User } from '../classes/user.class';

@Pipe({
    name: 'mention',
    standalone: true,
})
export class MentionPipe implements PipeTransform {
    transform(text: string, users: User[], roles?: Role[]): string {
        if (!text) {
            return text;
        }

        let transformedText = text;

        // Handle extended format: {{ user: {id: X, name: "Name"} }}
        const extendedUserMentionRegex = /\{\{\s*user:\s*\{\s*id:\s*(\d+)\s*,\s*name:\s*"([^"]+)"\s*\}\s*\}\}/g;
        transformedText = transformedText.replace(extendedUserMentionRegex, (match, userId, userName) => {
            // Use the name from the mention directly since it's already provided
            return `<span class="mention mention-user">@${userName}</span>`;
        });

        // Handle simple format: {{ user: X }} (for backward compatibility)
        if (users && users.length > 0) {
            const simpleUserMentionRegex = /\{\{\s*user:\s*(\d+)\s*\}\}/g;
            transformedText = transformedText.replace(simpleUserMentionRegex, (match, userId) => {
                const user = users.find(u => u.id === parseInt(userId, 10));
                return user ? `<span class="mention mention-user">@${user.name}</span>` : match;
            });
        }

        // Handle role mentions: {{ role: "rolename" }}
        if (roles && roles.length > 0) {
            const roleMentionRegex = /\{\{\s*role:\s*"([^"]+)"\s*\}\}/g;
            transformedText = transformedText.replace(roleMentionRegex, (match, roleKey) => {
                // Check if the role exists in our available roles by key
                const role = roles.find(r => r.key === roleKey);
                return role ? `<span class="mention mention-role">@${role.name}</span>` : match;
            });
        }

        return transformedText;
    }
}
